import { Pipe, PipeTransform } from '@angular/core';
import {ResourceAddressService} from "../../person.resource/services/resource.address.service";

/**
 * @ngModule RISCommonModule
 */
@Pipe({
	name: 'cpResourceAddress',
	pure: true
})

export class ResourceAddressPipe implements PipeTransform {
	constructor(private resourceAddressService:ResourceAddressService) {
	}

	transform(val: any): string {
		return this.resourceAddressService.getFormattedAddress(val);
	}

}
